import Cookies from 'js-cookie';

//wait for the document to load
document.addEventListener("DOMContentLoaded", function () {

    //check to see if we are on the blog or single post page
    if (document.body.classList.contains('blog') || document.body.classList.contains('single-post')) {

        //if the cookie is not set
        if (!Cookies.get('newsletterPopupClosed')) {

            //get the modal
            let modal = document.getElementById('modal');

            let success_message = false;

            //function to open the modal
            const openModal = () => {

                //show the modal
                document.body.classList.add("stop-scroll");
                document.documentElement.classList.add("stop-scroll");
                modal.classList.remove("hidden");
            };

            //function to close the modal
            const closeModal = () => {

                //hide the modal
                document.body.classList.remove("stop-scroll");
                document.documentElement.classList.remove("stop-scroll");
                modal.classList.add("hidden");
            };

            //interval function to check for a success message in the form
            let checkFormInterval = setInterval(function() {

                //check to see if we have a success message in our form
                success_message = document.querySelector(".newsletter-modal .ff-message-success");

                //if we have a success message
                if(success_message) {

                    Cookies.set('newsletterPopupClosed', 'true', { expires: 365 });

                    setTimeout(function() {

                        //close the modal down
                        closeModal();

                        //clear our interval
                        clearInterval(checkFormInterval);

                    }, 5000);
                }
            }, 100);

            //wait 7 seconds before showing the modal
            setTimeout(function(){

                //declare a new click event for closing the modal back down
                document.addEventListener('click', function (event) {

                    // If the clicked element isn't the hamburger, return
                    if (event.target.matches('.close-btn')) {

                        if(!success_message) {

                            //set a cookie to expire in 7 days
                            Cookies.set('newsletterPopupClosed', 'true', { expires: 7 });
                        } else {

                            //set a cookie to expire in 365 days
                            Cookies.set('newsletterPopupClosed', 'true', { expires: 365 });
                        }

                        //close the modal
                        closeModal();
                    }
                }, false);

                //trigger the modal
                openModal();
            }, 7000);
        }
    }
});